import { useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers";
import useForm from "../common/AsyncFormBox/useForm";
import { getInitialDateTimeValue } from "./internal/dateInputUtils";

/**
 * DateTimeInput component for selecting a date and time
 * @param {Object} props
 * @param {string} props.name - Name for the form field
 * @param {string} [props.label] - Label for the input
 * @param {Function} [props.onChange] - Callback when value changes, receives ISO string
 * @param {dayjs|string} [props.defaultValue] - Default value as dayjs object or ISO string
 * @param {boolean} [props.required] - Whether the field is required
 * @param {dayjs} [props.maxDateTime] - Maximum date and time
 * @param {boolean} [props.readOnly] - Whether field is read-only
 * @param {string} [props.size] - Size of the input field
 */
function DateTimeInput({ name, label, onChange, defaultValue, required, maxDateTime, readOnly, size }) {
  const form = useForm();
  const [value, setValue] = useState(() => getInitialDateTimeValue(defaultValue, name, form));

  function handleOnChange(newValue) {
    if (readOnly) return;
    setValue(newValue);
    form?.setValue(name, newValue);
    onChange && onChange(newValue);
  }

  return (
    <DateTimePicker
      ampm={false}
      format={"DD.MM.YYYY HH:mm"}
      slotProps={{
        textField: {
          fullWidth: true,
          name: name,
          required: required,
          InputProps: { readOnly },
          size: size,
        },
      }}
      label={label}
      value={value}
      onChange={handleOnChange}
      maxDateTime={maxDateTime}
    />
  );
}

export default DateTimeInput;
